module.exports = __webpack_public_path__ + "img/512.23ff2008.jpg";